import Operation from './Operation.js';
import AddEvent from './AddEvent.js';
import AddDeterministicEvent from './AddDeterministicEvent.js';
import SequenceRollEvent from 'session/SequenceRollEvent.js';

class InsertRollEvent extends Operation {
    constructor(mix, event, duration) {
        super(mix, event.getType());

        this.event = event;
        this.duration = duration;
    }

    addEvent(event, time, stepNumber) {
        new AddDeterministicEvent(this.mix, event, time, stepNumber)
            .execute();
    }

    execute() {
        // first see if it overlaps with existing roll event,
        // if so, insert within the roll event
        for (let i in this.events) {
            let existingEvent = this.events[i];
            if (existingEvent.isPrunable()) {
                continue;
            }
            if (this.event.step === existingEvent.step ||
                this.event.step === existingEvent.step + existingEvent.duration) {
                return;
            }
            if (this.event.step > existingEvent.step &&
                this.event.step < existingEvent.step + existingEvent.duration) {
                // then we must add it as a subevent
                let subEvent = this.event.initialSubEvent;
                subEvent.step = this.event.step;
                existingEvent.addSubEvent(subEvent);
                return;
            }
        }

        this.addEvent(this.event, 0, this.event.step);

        let eventOff = new SequenceRollEvent(
            false, this.event.initialSubEvent.resolution);
        eventOff.step = this.event.step + this.duration;
        this.addEvent(eventOff, 0, eventOff.step);
    }
}

export default InsertRollEvent;
